import { render, staticRenderFns } from "./ConsentPage.vue?vue&type=template&id=7d0a97ee&scoped=true&"
import script from "./ConsentPage.vue?vue&type=script&lang=js&"
export * from "./ConsentPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsentPage.vue?vue&type=style&index=0&id=7d0a97ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0a97ee",
  null
  
)

export default component.exports